import createVueApp from '@phoenix/createVueApp';
import NewsletterFormFooter from '@maison/components/form/NewsletterFormFooter.vue';

document.querySelectorAll('.phoenix-newsletter-form-footer').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('NewsletterFormFooter', NewsletterFormFooter);
  app.mount(el);
});
